import {
  collection,
  selection,
  composeReducers,
} from 'common/store/reducer';

import {
  NAMESPACE,
  SET_SELECTED,
  CLEAR_SELECTED,
  CLEAR_SEARCH,
} from './actions';

const initial = {
  ...collection.defaultSort('created'),
};

const selectGroup = (state, { group }) => (group
  ? selection.setSelected(state, { selected: group })
  : selection.clearSelected(state)
);

const clearSearch = (state) => ({
  ...state,
  query: undefined,
});

const groupsReducer = (state = initial, action) => {
  const reducer = {
    [SET_SELECTED]: selectGroup,
    [CLEAR_SELECTED]: selection.clearSelected,
    [CLEAR_SEARCH]: clearSearch,
  }[action.type];

  return reducer ? reducer(state, action) : state;
};
export default composeReducers(
  collection.factory(NAMESPACE),
  groupsReducer,
);
